import { render, staticRenderFns } from "./officeOrderApprove.vue?vue&type=template&id=395705be&scoped=true"
import script from "./officeOrderApprove.vue?vue&type=script&lang=js"
export * from "./officeOrderApprove.vue?vue&type=script&lang=js"
import style0 from "./officeOrderApprove.vue?vue&type=style&index=0&id=395705be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395705be",
  null
  
)

export default component.exports